import { render, staticRenderFns } from "./online-number.vue?vue&type=template&id=39e2c13b&scoped=true"
import script from "./online-number.vue?vue&type=script&lang=ts"
export * from "./online-number.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2c13b",
  null
  
)

export default component.exports